export default __webpack_public_path__ + "static/media/arrow-down.c2c95816.svg";